import { useState, useRef, useEffect } from 'react';
import { Bd, Mo } from './shared';
import { GOLD, DEBIT_RED, MONO } from '../lib/constants';

/* ── Complete category list — mirrors CheckpointModal ── */
const ALL_CATEGORIES = [
  // ── PERSONAL: Discretionary ──
  { value: 'FOOD_AND_DRINK',    label: 'Food & Drink',          type: 'personal', classification: 'personal', group: 'discretionary' },
  { value: 'DINING_OUT',        label: 'Dining Out',            type: 'personal', classification: 'personal', group: 'discretionary' },
  { value: 'ENTERTAINMENT',     label: 'Entertainment',         type: 'personal', classification: 'personal', group: 'discretionary' },
  { value: 'SHOPPING',          label: 'Shopping',              type: 'personal', classification: 'personal', group: 'discretionary' },
  { value: 'PERSONAL_CARE',     label: 'Personal Care',         type: 'personal', classification: 'personal', group: 'discretionary' },
  { value: 'TRAVEL',            label: 'Travel',                type: 'personal', classification: 'personal', group: 'discretionary' },
  { value: 'RECREATION',        label: 'Recreation',            type: 'personal', classification: 'personal', group: 'discretionary' },
  { value: 'FITNESS',           label: 'Fitness',               type: 'personal', classification: 'personal', group: 'discretionary' },
  { value: 'COFFEE_SHOPS',      label: 'Coffee Shops',          type: 'personal', classification: 'personal', group: 'discretionary' },
  { value: 'PET_CARE',          label: 'Pet Care',              type: 'personal', classification: 'personal', group: 'discretionary' },
  { value: 'BEAUTY_SALON',      label: 'Beauty & Salon',        type: 'personal', classification: 'personal', group: 'discretionary' },
  { value: 'ALCOHOL_TOBACCO',   label: 'Alcohol & Tobacco',     type: 'personal', classification: 'personal', group: 'discretionary' },
  // ── PERSONAL: Essential ──
  { value: 'GROCERIES',         label: 'Groceries',             type: 'personal', classification: 'personal', group: 'essential' },
  { value: 'RENT_AND_UTILITIES',label: 'Rent & Bills',          type: 'personal', classification: 'personal', group: 'essential' },
  { value: 'HOUSING',           label: 'Housing',               type: 'personal', classification: 'personal', group: 'essential' },
  { value: 'TRANSPORTATION',    label: 'Transportation',         type: 'personal', classification: 'personal', group: 'essential' },
  { value: 'GAS_FUEL',          label: 'Gas & Fuel',            type: 'personal', classification: 'personal', group: 'essential' },
  { value: 'MEDICAL',           label: 'Medical',               type: 'personal', classification: 'personal', group: 'essential' },
  { value: 'HEALTHCARE',        label: 'Healthcare',            type: 'personal', classification: 'personal', group: 'essential' },
  { value: 'CHILDCARE',         label: 'Childcare',             type: 'personal', classification: 'personal', group: 'essential' },
  { value: 'EDUCATION',         label: 'Education',             type: 'personal', classification: 'personal', group: 'essential' },
  { value: 'HOME_IMPROVEMENT',  label: 'Home Improvement',      type: 'personal', classification: 'personal', group: 'essential' },
  { value: 'PARKING_TOLLS',     label: 'Parking & Tolls',       type: 'personal', classification: 'personal', group: 'essential' },
  // ── PERSONAL: Fixed / Recurring ──
  { value: 'PHONE_SERVICE',     label: 'Phone Service',         type: 'personal', classification: 'personal', group: 'fixed' },
  { value: 'INTERNET',          label: 'Internet',              type: 'personal', classification: 'personal', group: 'fixed' },
  { value: 'SUBSCRIPTIONS',     label: 'Subscriptions',         type: 'personal', classification: 'subscriptions', group: 'fixed' },
  { value: 'STORAGE_UNIT',      label: 'Storage Unit',          type: 'personal', classification: 'personal', group: 'fixed' },
  // ── PERSONAL: Insurance ──
  { value: 'PERSONAL_INSURANCE',label: 'Personal Insurance',    type: 'personal', classification: 'insurance', group: 'insurance' },
  { value: 'CAR_INSURANCE',     label: 'Car Insurance',         type: 'personal', classification: 'insurance', group: 'insurance' },
  { value: 'HEALTH_INSURANCE',  label: 'Health Insurance',      type: 'personal', classification: 'insurance', group: 'insurance' },
  { value: 'LIFE_INSURANCE',    label: 'Life Insurance',        type: 'personal', classification: 'insurance', group: 'insurance' },
  // ── PERSONAL: Debt Payments ──
  { value: 'LOAN_DEBT_PAYMENT',     label: 'Loan / Debt Payment',    type: 'personal', classification: 'debt_payment', group: 'debt' },
  { value: 'CREDIT_CARD_PAYMENT',   label: 'Credit Card Payment',    type: 'personal', classification: 'debt_payment', group: 'debt' },
  { value: 'AUTO_LOAN_PAYMENT',     label: 'Auto Loan Payment',      type: 'personal', classification: 'vehicle_payment', group: 'debt' },
  { value: 'MORTGAGE_PAYMENT',      label: 'Mortgage Payment',       type: 'personal', classification: 'debt_payment', group: 'debt' },
  { value: 'STUDENT_LOAN_PAYMENT',  label: 'Student Loan Payment',   type: 'personal', classification: 'debt_payment', group: 'debt' },
  { value: 'PERSONAL_LOAN_PAYMENT', label: 'Personal Loan Payment',  type: 'personal', classification: 'debt_payment', group: 'debt' },
  { value: 'MEDICAL_DEBT_PAYMENT',  label: 'Medical Debt Payment',   type: 'personal', classification: 'debt_payment', group: 'debt' },
  { value: 'BNPL_PAYMENT',          label: 'Buy Now Pay Later',      type: 'personal', classification: 'debt_payment', group: 'debt' },
  // ── PERSONAL: Vehicle ──
  { value: 'VEHICLE_AUTO',  label: 'Vehicle / Auto Payment',  type: 'personal', classification: 'vehicle_payment', group: 'vehicle' },
  // ── PERSONAL: Other ──
  { value: 'INVESTMENTS',   label: 'Investment',               type: 'personal', classification: 'investment', group: 'other' },
  { value: 'OTHER',         label: 'Other',                    type: 'personal', classification: 'personal', group: 'other' },
  // ── BUSINESS: COGS / Revenue Related ──
  { value: 'COST_OF_GOODS',        label: 'Cost of Goods (COGS)',      type: 'business', classification: 'business_cogs', group: 'business_cogs' },
  { value: 'SUPPLIES_EQUIPMENT',   label: 'Supplies & Equipment',      type: 'business', classification: 'business_operations', group: 'business_cogs' },
  { value: 'SHIPPING_DELIVERY',    label: 'Shipping & Delivery',       type: 'business', classification: 'business_operations', group: 'business_cogs' },
  // ── BUSINESS: Operations ──
  { value: 'BUSINESS_OPERATIONS',    label: 'Business Operations',       type: 'business', classification: 'business_operations', group: 'business_ops' },
  { value: 'BUSINESS_RENT',          label: 'Business Rent',             type: 'business', classification: 'business_operations', group: 'business_ops' },
  { value: 'BUSINESS_UTILITIES',     label: 'Business Utilities',        type: 'business', classification: 'business_operations', group: 'business_ops' },
  { value: 'BUSINESS_SUBSCRIPTIONS', label: 'Business Software',         type: 'business', classification: 'business_operations', group: 'business_ops' },
  { value: 'ADVERTISING_MARKETING',  label: 'Advertising & Marketing',   type: 'business', classification: 'business_operations', group: 'business_ops' },
  { value: 'MERCHANT_FEES',          label: 'Merchant Fees',             type: 'business', classification: 'business_operations', group: 'business_ops' },
  { value: 'PROFESSIONAL_SERVICES',  label: 'Professional Services',     type: 'business', classification: 'business_operations', group: 'business_ops' },
  { value: 'POS_SYSTEM_FEES',        label: 'POS System Fees',           type: 'business', classification: 'business_operations', group: 'business_ops' },
  { value: 'BUSINESS_PHONE_INTERNET',label: 'Business Phone & Internet', type: 'business', classification: 'business_operations', group: 'business_ops' },
  { value: 'BUSINESS_TRAVEL',        label: 'Business Travel',           type: 'business', classification: 'business_operations', group: 'business_ops' },
  // ── BUSINESS: People ──
  { value: 'PAYROLL_CONTRACTORS', label: 'Payroll & Contractors', type: 'business', classification: 'payroll_contractors', group: 'business_people' },
  { value: 'PAYROLL_WAGES',       label: 'Payroll & Wages',       type: 'business', classification: 'payroll_contractors', group: 'business_people' },
  { value: 'CONTRACTOR_PAYMENTS', label: 'Contractor Payments',   type: 'business', classification: 'payroll_contractors', group: 'business_people' },
  // ── BUSINESS: Taxes & Insurance ──
  { value: 'BUSINESS_TAXES',    label: 'Business Taxes',     type: 'business', classification: 'business_taxes', group: 'business_tax_ins' },
  { value: 'BUSINESS_INSURANCE',label: 'Business Insurance', type: 'business', classification: 'business_operations', group: 'business_tax_ins' },
  // ── BUSINESS: Vehicle ──
  { value: 'VEHICLE_FLEET', label: 'Vehicle / Fleet', type: 'business', classification: 'vehicle_payment', group: 'business_vehicle' },
  // ── BUSINESS: Debt ──
  { value: 'MCA_REPAYMENT',  label: 'MCA Repayment',  type: 'business', classification: 'debt_payment', group: 'business_debt' },
  { value: 'BUSINESS_LOAN',  label: 'Business Loan',  type: 'business', classification: 'debt_payment', group: 'business_debt' },
  { value: 'SBA_LOAN',       label: 'SBA Loan',       type: 'business', classification: 'debt_payment', group: 'business_debt' },
  { value: 'LINE_OF_CREDIT', label: 'Line of Credit', type: 'business', classification: 'debt_payment', group: 'business_debt' },
  // ── BUSINESS: Other ──
  { value: 'OTHER', label: 'Other', type: 'business', classification: 'business_operations', group: 'business_other' },
  // ── OTHER ──
  { value: 'TRANSFER', label: 'Transfer', type: 'other', classification: 'transfer', group: 'other' },
];

// Section headers per group key
const GROUP_LABELS = {
  discretionary: 'DISCRETIONARY',
  essential: 'ESSENTIAL',
  fixed: 'FIXED / RECURRING',
  insurance: 'INSURANCE',
  debt: 'DEBT PAYMENTS',
  vehicle: 'VEHICLE',
  other: 'OTHER',
  business_cogs: 'COST OF GOODS',
  business_ops: 'OPERATIONS',
  business_people: 'PEOPLE',
  business_tax_ins: 'TAXES & INSURANCE',
  business_vehicle: 'VEHICLE',
  business_debt: 'DEBT',
  business_other: 'OTHER',
};

export function ReclassifyTransactionModal({ transaction, currentType, currentCategory, onSave, onClose }) {
  const [accountType, setAccountType] = useState(currentType || 'personal');
  const [category, setCategory] = useState(currentCategory || '');
  const [applyToAll, setApplyToAll] = useState(false);
  const [isSaving, setIsSaving] = useState(false);

  // When switching type tabs, reset category
  const handleTypeChange = (newType) => {
    setAccountType(newType);
    setCategory('');
  };

  const handleSave = async () => {
    if (accountType !== 'ignore' && !category) return;
    setIsSaving(true);
    try {
      await onSave({
        merchant: transaction.merchant,
        accountType: accountType === 'ignore' ? 'spending' : accountType,
        category: accountType === 'ignore' ? 'IGNORED' : category,
        applyToAll,
        transactionId: transaction.id || `${transaction.merchant}-${transaction.date}-${transaction.amount}`,
      });
      onClose();
    } catch (err) {
      console.error('Failed to reclassify:', err);
      setIsSaving(false);
    }
  };

  const filteredCategories = ALL_CATEGORIES.filter(c => c.type === accountType);

  // Group categories
  const grouped = filteredCategories.reduce((acc, cat) => {
    const g = cat.group || 'other';
    if (!acc[g]) acc[g] = [];
    acc[g].push(cat);
    return acc;
  }, {});

  const canSave = accountType === 'ignore' || !!category;

  return (
    <>
      {/* Backdrop */}
      <div
        onClick={onClose}
        style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.75)', zIndex: 9998 }}
      />

      {/* Modal */}
      <div
        data-testid="reclassify-modal"
        style={{
          position: 'fixed', top: '50%', left: '50%', transform: 'translate(-50%, -50%)',
          width: '92%', maxWidth: 480,
          background: '#111', border: '1px solid var(--ghost)',
          borderRadius: 16,
          zIndex: 9999,
          maxHeight: '88vh', display: 'flex', flexDirection: 'column',
        }}
      >

        {/* Header */}
        <div style={{ padding: '8px 20px 12px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', borderBottom: '1px solid var(--faint)' }}>
          <div>
            <Mo style={{ fontSize: 9, color: 'var(--gold)', letterSpacing: 2, display: 'block', marginBottom: 4 }}>RECLASSIFY TRANSACTION</Mo>
            <Bd style={{ fontSize: 14, color: 'var(--light)', fontWeight: 700 }}>{transaction?.merchant}</Bd>
            {transaction?.amount != null && (
              <Mo style={{ fontSize: 11, color: DEBIT_RED }}>${Math.abs(transaction.amount).toFixed(2)}</Mo>
            )}
          </div>
          <button onClick={onClose} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 8 }}>
            <svg width={18} height={18} viewBox="0 0 24 24" fill="none" stroke="var(--mute)" strokeWidth="2">
              <path d="M18 6L6 18M6 6l12 12" />
            </svg>
          </button>
        </div>

        {/* Type Tabs */}
        <div style={{ padding: '12px 20px 0', display: 'flex', gap: 8 }}>
          {[
            { id: 'personal', label: 'Personal', color: '#22c55e' },
            { id: 'business', label: 'Business', color: '#3b82f6' },
            { id: 'ignore',   label: 'Ignore',   color: 'var(--mute)' },
          ].map(tab => (
            <button
              key={tab.id}
              data-testid={`type-tab-${tab.id}`}
              onClick={() => handleTypeChange(tab.id)}
              style={{
                flex: 1, padding: '9px 4px',
                background: accountType === tab.id ? `${tab.color}18` : 'var(--faint)',
                border: `1.5px solid ${accountType === tab.id ? tab.color : 'var(--ghost)'}`,
                borderRadius: 10, cursor: 'pointer',
                fontFamily: MONO, fontSize: 10, fontWeight: 700,
                color: accountType === tab.id ? tab.color : 'var(--mute)',
                letterSpacing: 0.5,
                transition: 'all 0.15s',
              }}
            >
              {tab.label.toUpperCase()}
            </button>
          ))}
        </div>

        {/* Category List or Ignore confirm */}
        {accountType === 'ignore' ? (
          <div style={{ padding: '20px', flex: 1 }}>
            <div style={{ background: 'var(--faint)', borderRadius: 12, padding: 16, textAlign: 'center' }}>
              <Mo style={{ fontSize: 12, color: 'var(--mute)', display: 'block' }}>
                This merchant will be skipped in future analyses.
              </Mo>
            </div>
          </div>
        ) : (
          <div style={{ flex: 1, overflowY: 'auto', padding: '12px 20px 0' }}>
            {Object.entries(grouped).map(([groupKey, items]) => (
              <div key={groupKey} style={{ marginBottom: 14 }}>
                <Mo style={{ fontSize: 8, color: 'var(--mute)', letterSpacing: 1.5, display: 'block', marginBottom: 5, paddingLeft: 2 }}>
                  {GROUP_LABELS[groupKey] || groupKey.toUpperCase()}
                </Mo>
                <div style={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                  {items.map(opt => (
                    <button
                      key={opt.value}
                      data-testid={`category-opt-${opt.value}`}
                      onClick={() => setCategory(opt.value)}
                      style={{
                        width: '100%', padding: '9px 12px', textAlign: 'left',
                        background: category === opt.value ? `${GOLD}18` : 'var(--faint)',
                        border: `1px solid ${category === opt.value ? GOLD : 'var(--ghost)'}`,
                        borderRadius: 8, cursor: 'pointer',
                        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                        transition: 'all 0.12s',
                      }}
                      onMouseEnter={e => { if (category !== opt.value) e.currentTarget.style.background = 'var(--surface)'; }}
                      onMouseLeave={e => { if (category !== opt.value) e.currentTarget.style.background = 'var(--faint)'; }}
                    >
                      <Bd style={{ fontSize: 12, color: category === opt.value ? GOLD : 'var(--light)', fontWeight: category === opt.value ? 700 : 400 }}>
                        {opt.label}
                      </Bd>
                      {category === opt.value && (
                        <svg width={14} height={14} viewBox="0 0 24 24" fill="none" stroke={GOLD} strokeWidth="2.5">
                          <path d="M20 6L9 17l-5-5" />
                        </svg>
                      )}
                    </button>
                  ))}
                </div>
              </div>
            ))}
            <div style={{ height: 8 }} />
          </div>
        )}

        {/* Footer */}
        <div style={{ padding: '12px 20px', borderTop: '1px solid var(--faint)', background: '#111' }}>
          {/* Apply to all checkbox */}
          <button
            data-testid="apply-to-all-toggle"
            onClick={() => setApplyToAll(a => !a)}
            style={{ display: 'flex', alignItems: 'center', gap: 10, background: 'none', border: 'none', cursor: 'pointer', padding: '4px 0', marginBottom: 12, width: '100%' }}
          >
            <div style={{
              width: 18, height: 18, borderRadius: 5,
              border: `2px solid ${applyToAll ? GOLD : 'var(--ghost)'}`,
              background: applyToAll ? GOLD : 'transparent',
              display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
            }}>
              {applyToAll && (
                <svg width={10} height={10} viewBox="0 0 24 24" fill="none" stroke="#111" strokeWidth="3">
                  <path d="M20 6L9 17l-5-5" />
                </svg>
              )}
            </div>
            <Mo style={{ fontSize: 11, color: applyToAll ? 'var(--light)' : 'var(--mute)', textAlign: 'left' }}>
              Apply to all transactions from <strong>{transaction?.merchant}</strong>
            </Mo>
          </button>

          <button
            data-testid="save-classification-btn"
            onClick={handleSave}
            disabled={!canSave || isSaving}
            style={{
              width: '100%', padding: '14px',
              background: canSave ? GOLD : 'var(--ghost)',
              border: 'none', borderRadius: 12,
              cursor: canSave ? 'pointer' : 'not-allowed',
              fontFamily: MONO, fontSize: 12, fontWeight: 700,
              color: canSave ? '#111' : 'var(--mute)',
              letterSpacing: 1, transition: 'background 0.15s',
            }}
          >
            {isSaving ? 'SAVING...' : accountType === 'ignore' ? 'IGNORE THIS MERCHANT' : `SAVE — ${category ? ALL_CATEGORIES.find(c => c.value === category)?.label : 'SELECT A CATEGORY'}`}
          </button>
        </div>
      </div>
    </>
  );
}
